import { FC, PropsWithChildren } from "react";
import {
  Button,
  Container,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

import { ReactComponent as Logo } from "../assets/logo.svg";
import { useWeb3ProviderContext } from "../contexts/Web3Provider";

export const Layout: FC<PropsWithChildren> = ({ children }) => {
  const { connectProvider, connectedProvider, disconnectProvider } =
    useWeb3ProviderContext();

  const getHiddenAddress = (address: string) => {
    return `${address.slice(0, 6)} ･･･ ${address.slice(-4)}`;
  };

  return (
    <Flex
      height="100%"
      width="100%"
      bg="gray.100"
      flexDirection="column"
      alignItems="center"
    >
      <Flex bg="white" width="100%">
        <Container maxWidth="1200px">
          <Flex alignItems="center" justifyContent="space-between" paddingY="4">
            <Logo />
            {connectedProvider.status === "successful" && (
              <Button pointerEvents="none">
                {getHiddenAddress(connectedProvider.data.address)}
              </Button>
            )}
          </Flex>
        </Container>
      </Flex>
      <Container maxWidth="1200px" height="100%" paddingTop="12">
        {children}
      </Container>
    </Flex>
  );
};
